import { render, staticRenderFns } from "./RateHeaderAdd.vue?vue&type=template&id=056e1cc2&scoped=true&"
import script from "./RateHeaderAdd.vue?vue&type=script&lang=js&"
export * from "./RateHeaderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e1cc2",
  null
  
)

export default component.exports